export const getSafeKey = (prefix: string, item?: any, index?: number) => {
  const id = item?.uuid || item?.id || item?.uid || (index !== undefined ? index : Math.random().toString(36).substr(2, 9));
  return `${prefix}-${id}`;
};

export const sanitizeData = <T extends object>(data: T[] | null | undefined): T[] => {
  if (!data || !Array.isArray(data)) return [];
  return data;
};

export const formatLargeBudget = (num: number) => {
  if (num >= 1e9) return (num / 1e9).toFixed(1) + 'B';
  if (num >= 1e6) return (num / 1e6).toFixed(1) + 'M';
  if (num >= 1e3) return (num / 1e3).toFixed(1) + 'K';
  return num.toString();
};

export const isGenericVentureId = (id?: string | null): boolean => {
  if (!id) return true;
  const trimmed = String(id).trim();
  return (
    trimmed.length < 5 ||
    /^(\d+|idea[-_]?\d+|venture[-_]?\d+|item[-_]?\d+|temp|null|undefined|unnamed)$/i.test(trimmed)
  );
};

export const generateVentureId = (title: string, location?: string, existingId?: string): string => {
  if (existingId && !isGenericVentureId(existingId)) {
    return existingId;
  }
  const cleanTitle = (title || 'venture').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 36);
  const rawKey = (title || '').trim().toLowerCase() + (location || '').trim().toLowerCase();
  let hashNum = 0;
  for (let i = 0; i < rawKey.length; i++) {
    hashNum = ((hashNum << 5) - hashNum) + rawKey.charCodeAt(i);
    hashNum |= 0;
  }
  const hash = Math.abs(hashNum).toString(36);
  return `vtr-${cleanTitle || 'entity'}-${hash}`;
};

